const emissionsPageData = {
    title: "Energy and Emissions",
    paraghraphOne: "To support SAB’s operational Net Zero target by 2035, SAB's energy reduction initiatives include replacing old monitors with Liquid Crystal Display (LCD) monitors and installing light sensors to ensure that all lights are switched off after working hours. All the Bank’s lights are also connected to timers as part of the building management system to help reduce electricity usage. The recycled materials used in our installed floors, along with the highly insulated walls, reduce heat exchange to limit the need for air-conditioning.",
    paraghraphTwo: "The following table gives an overview of the bank’s carbon footprint and value chain as it is visible today. Notably, the scope for emissions in our operations has been extended to include the new headquarters in 2023, while branches were included for both 2023 and 2022. This explains a rise in emissions and is in line with our ongoing journey on the decarbonisation trajectory, which relies on relevance, completeness, consistency, transparency, and accuracy of information.",
    sectionOne: {
        title: "Energy consumption",
        table: {
            headers: ["Measure", "2023", "2022 (restated)"],
            data: [
                {
                    title: "Total electricity consumption",
                    measure: "kWh",
                    2023: "69,099,385",
                    2022: "63,915,431*",
                },
            ]
        },
        gridOne: [
            {
                spanOne: "2021",
                number: 95074,
                spanTwo: "metre2",
                text: "",
            },
            {
                spanOne: "2022",
                number: 95074,
                spanTwo: "metre2",
                text: "",
            },
            {
                spanOne: "",
                spanTwo: "",
                number: null,
                text: "Total space SAB’s main office buildings"
            }
        ],
        gridTwo: [
            {
                spanOne: "2021",
                number: 35872923,
                spanTwo: "kWh",
                text: "",
            },
            {
                spanOne: "2022",
                number: 27796691,
                spanTwo: "kWh",
                text: "",
            },
            {
                spanOne: "",
                spanTwo: "",
                number: null,
                text: "Total electricity consumption"
            }
        ]
    },
    sectionTwo: {
        title: "GHG Emissions",
        subtitle: "In 2022, SAB conducted a benchmark analysis of its GHG emissions in 2021. The following graphic outlines the GHG elements identified as relevant to SAB:",
        image: "plan-one.svg",
    },
    sectionThree: {
        description: "We recognize that SAB’s biggest impact on the environment is through our financed emissions. However, understanding the GHG emissions and intensity within our financed portfolio is a challenging exercise requiring deep levels of data from our clients. SAB has full intention of reviewing and baselining our financed emissions during the course of the next calendar year. For now, financed emissions have not yet been included in the preliminary study.",
        labels: [
            [
                {
                    size: '10',
                    subtitle: "2023"
                },
                {
                    size: '40',
                    number: 15683,
                    unit: <span>Tonns of CO<sub>2</sub>eq</span>,
                },
                {
                    size: '40',
                    subtitle: "Direct GHG emissions (Scope 1)",
                }
            ],
            [
                {
                    size: "10",
                    subtitle: "2023",
                },
                {
                    size: "40",
                    number: 39248,
                    unit: <span>Tonns of CO<sub>2</sub>eq</span>,
                },
                {
                    size: "40",
                    subtitle: "Indirect GHG emissions (Scope 2)",
                }
            ],
            [
                {
                    size: "10",
                    subtitle: "2023",
                },
                {
                    size: "40",
                    number: 532590,
                    unit: <span>Tonns of CO<sub>2</sub>eq</span>,
                },
                {
                    size: "40",
                    subtitle: "Indirect GHG emissions (Scope 3) excluding lending and investments",
                }
            ],
            [
                {
                    size: "10",
                    subtitle: "2023",
                },
                {
                    size: "40",
                    number: 587522,
                    unit: <span>Tonns of CO<sub>2</sub>eq</span>,
                },
                {
                    size: "40",
                    subtitle: "Total GHG emissions",
                }
            ],

        ],
        pargraph: "The increase in 2023 compared to 2022 can be attributed to several factors.Firstly, as mentioned above, we have moved into our new headquarters, which contributed to our GHG footprint.In the long run, however, the new building will help us cut emissions due to its environmental efficiency.Secondly, increased operating expenses led to an increase in scope 3 emissions. In spite of the increase, we are confident that the investments we made will help us to ultimately reach our environmental goals, and we remain committed to our targets. In addition, we have solidified our GHG reporting, including obtaining external assurance, which allows us to better manage our emissions going forward.",
    },
    sectionFour: {
        title: "Scope 3 Emissions",
        labels: [
            [
                {
                    size: '25',
                    subtitle: "2023 emissions"
                },
                {
                    size: '20',
                    number: 395157,
                    unit: <span>Tonns of CO<sub>2</sub>eq</span>,
                },
                {
                    size: '20',
                    percentage: 74.2,
                },
                {
                    size: '30',
                    subtitle: "Purchased goods and services"
                }
            ],
            [
                {
                    size: '25',
                    subtitle: "2023 emissions"
                },
                {
                    size: '20',
                    number: 122922,
                    unit: <span>Tonns of CO<sub>2</sub>eq</span>,
                },
                {
                    size: '20',
                    percentage: 23.1,
                },
                {
                    size: '30',
                    subtitle: "Capital goods"
                },
            ],
            [
                {
                    size: '25',
                    subtitle: "2023 emissions"
                },
                {
                    size: '20',
                    number: 11480,
                    unit: <span>Tonns of CO<sub>2</sub>eq</span>,
                },
                {
                    size: '20',
                    percentage: 2.2,
                },
                {
                    size: '30',
                    subtitle: "Employee Commuting"
                },
            ],
            [
                {
                    size: '25',
                    subtitle: "2023 emissions"
                },
                {
                    size: '20',
                    number: 3031,
                    unit: <span>Tonns of CO<sub>2</sub>eq</span>,
                },
                {
                    size: '20',
                    percentage: 0.6,
                },
                {
                    size: '30',
                    subtitle: "Fuel and energy-related activities"
                },
            ],
        ]
    },
    sectionSeven: {

        title: "Financed Emissions",
        paragraphOne: "In line with our commitment to become a Net Zero bank by 2060 or earlier, we are reviewing our financed emissions baseline for select sectors in 2024. Financed emissions reflect the GHG emissions associated with our on-balance sheet financing portfolio. In disclosing our own financed emissions footprint, we are seeking to lead by example, providing transparency to our key stakeholders.",
        paragraphTwo: "Determining our financed emissions baseline involves various methodological choices, including which sectors, clients, and products to include, as well as which parts of the value chain to focus on. We are considering what is most suitable for our portfolio and operating environment in the Kingdom, drawing on industry standards like those developed by the Partnership for Carbon Accounting Financials (PCAF).",
        paragraphThree: "Measuring financed emissions poses challenges due to limited public emissions disclosure among companies in the Kingdom. Therefore, we have to rely on proxies and modelled estimates, following industry norms. Over time, we expect emissions data quality and accuracy to improve as more companies disclose their emissions. Efforts like the Saudi Exchange’s voluntary ESG disclosure guidelines and the Saudi Central Bank’s evaluation of IFRS ISSB sustainability standards are encouraging steps toward disclosure of financed emissions, which SAB will consider in due course. As we navigate these complexities of measuring and disclosing financed emissions, we will remain committed to transparency, accountability, and sustainability.",
    },
    sectionFive: {
        boxOne: {
            title: "Waste",
            subtitle: "In our transition towards a paperless environment, we discourage the printing of business-related correspondence and reports which can be accessed electronically. During the year under review, we launched a recycling programme in 4 of our buildings. As part of the programme, dry and wet waste bins for paper recycling were provided. Various smart recycling techniques have been designed and built into our facilities to avoid waste being transported to landfill zones for disposal.",
        },
        paragraphOne: "Positive spinoffs in these initiatives include the collection of approximately 340kg of recycled waste per month. SAB is the Kingdom’s first bank to achieve zero single-use non-recycled plastic bottles across offices – we are saving 2.6 million plastic water bottles per year as we migrate to filtered water coolers.",
        paragraphTwo: "In addition, we undertook a large-scale scan-and-shred exercise at our document warehouse in 2022, resulting in 205,000 tonnes of waste recycled through a reputable partner. We will continue efforts to manage our waste effectively by recycling wherever and whatever is possible.",
        title: "Materials Consumption and Waste*",
        labels: [
            [
                {
                    size: '10',
                    subtitle: "2023",
                },
                {
                    size: '40',
                    number: 13200,
                    unit: "kg"
                },
                {
                    size: '40',
                    subtitle: "Total paper recycled"
                }
            ],
            [
                {
                    size: '10',
                    subtitle: "2023",
                },
                {
                    size: '40',
                    number: 44900,
                    unit: "kg"
                },
                {
                    size: '40',
                    subtitle: "Total waste produced"
                }
            ],
        ],
        note: "*SAB started collecting waste data in 2022, which will serve as a benchmark for future reporting."
    },
    sectionSix: {
        card: {
            image: {
                name: "water-2.jpg",
                alt: "Wonderfull view for shore of rocks and sea",
            }
        },
        info: {
            title: "Water",
            paragraphOne: "SAB has undertaken extensive renovation of its water infrastructure throughout branch premises by installing motion-detecting infrared taps to save water. We also implemented a lower water consumption system in our flushing toilet systems, which mostly use underground water.",
            // paragraphTwo : "We also implemented a lower water consumption system in our flushing toilet systems, which mostly use underground water. SAB’s buildings rely solely on water provided by the National Water Company."
        },
        title: "Water Consumption",
        labels: [
            [
                {
                    size: '10',
                    subtitle: "2023",
                },
                {
                    size: '40',
                    number: 119772,
                    unit: "m3"
                },
                {
                    size: '40',
                    subtitle: "Total water consumption"
                }
            ],
            [
                {
                    size: '10',
                    subtitle: "2023",
                },
                {
                    size: '40',
                    number: 31,
                    unit: <span>m<sup>3</sup>/employee</span>
                },
                {
                    size: '40',
                    subtitle: "Water consumption intensity"
                }
            ],
        ],
        note: "SAB’s buildings rely solely on water provided by the National Water Company. "
    }
}

export default emissionsPageData;